import { useCallback } from "react";
import { AnnexDocument } from "./useAnnexActions";

interface UseAnnexLocalStorageReturn {
  syncAnnex: (companyId: number) => AnnexDocument[] | null;
  updateAnnex: (companyId: number, data: AnnexDocument[]) => void;
  deleteAnnex: (companyId: number) => void;

  syncPredefinedAnnex: (
    companyId: number
  ) => Record<number, AnnexDocument[]> | null;
  updatePredefinedAnnex: (
    companyId: number,
    data: Record<number, AnnexDocument[]>
  ) => void;
  deletePredefinedAnnex: (companyId: number) => void;
}

const SYNC_ANNEX = "annex";
const SYNC_PREDEFINED_ANNEX = "predefinedAnnex";

export function useAnnexLocalStorage(): UseAnnexLocalStorageReturn {
  const syncAnnex = useCallback((companyId: number): AnnexDocument[] | null => {
    try {
      const key = `${SYNC_ANNEX}_${companyId}`;
      const stored = localStorage.getItem(key);
      if (stored) {
        return JSON.parse(stored) as AnnexDocument[];
      }
      return null;
    } catch {
      return null;
    }
  }, []);

  const updateAnnex = useCallback(
    (companyId: number, data: AnnexDocument[]): void => {
      try {
        const key = `${SYNC_ANNEX}_${companyId}`;
        localStorage.setItem(key, JSON.stringify(data));
      } catch {
        return;
      }
    },
    []
  );

  const deleteAnnex = useCallback((companyId: number): void => {
    try {
      const key = `${SYNC_ANNEX}_${companyId}`;
      localStorage.removeItem(key);
    } catch {
      return;
    }
  }, []);

  const syncPredefinedAnnex = useCallback(
    (companyId: number): Record<number, AnnexDocument[]> | null => {
      try {
        const key = `${SYNC_PREDEFINED_ANNEX}_${companyId}`;
        const stored = localStorage.getItem(key);
        if (stored) {
          return JSON.parse(stored) as Record<number, AnnexDocument[]>;
        }
        return null;
      } catch {
        return null;
      }
    },
    []
  );

  const updatePredefinedAnnex = useCallback(
    (companyId: number, data: Record<number, AnnexDocument[]>): void => {
      try {
        const key = `${SYNC_PREDEFINED_ANNEX}_${companyId}`;
        localStorage.setItem(key, JSON.stringify(data));
      } catch {
        return;
      }
    },
    []
  );

  const deletePredefinedAnnex = useCallback((companyId: number): void => {
    try {
      const key = `${SYNC_PREDEFINED_ANNEX}_${companyId}`;
      localStorage.removeItem(key);
    } catch {
      return;
    }
  }, []);

  return {
    syncAnnex,
    updateAnnex,
    deleteAnnex,
    syncPredefinedAnnex,
    updatePredefinedAnnex,
    deletePredefinedAnnex,
  };
}
